<script setup>

import { ref, watch, onMounted } from 'vue'
import store from '@/store'
import eventBus from '@/plugins/event-bus'
import { createToast } from 'mosha-vue-toastify'

const warningTimer = ref(null)
const logoutTimer = ref(null)

const sessionLogoutSeconds = ref(2 * 60)
const sessionWarningSeconds = ref(2 * 60 - 20)

watch(() => store.state.auth.status.loggedIn, (loggedIn) => {
    if(loggedIn) {
        setTimers()
    } else {
        clearTimers()
    }
})

const setTimers = () => {
    warningTimer.value = setTimeout(() => {
        warningMessage()
    }, sessionWarningSeconds.value * 1000)

    logoutTimer.value = setTimeout(() => {
        clearTimers()

        store.dispatch('auth/logout')
    }, sessionLogoutSeconds.value * 1000)
}

const clearTimers = () => {
    clearTimeout(warningTimer.value)
    clearTimeout(logoutTimer.value)
}

const warningMessage = () => {
    createToast('La session va expirer et vous allez être déconnecté', {
        timeout: 5000,
        hideProgressBar: true,
        type: 'warning',
        swipeClose: true,
        position: 'top-center',
    })
}

onMounted(() => {
    let sessionLogoutMinutes = store.state.token.validitySessionMinutes
    if(sessionLogoutMinutes) {
        sessionLogoutSeconds.value = sessionLogoutMinutes * 60
        sessionWarningSeconds.value = sessionLogoutMinutes * 60 - 20
    }

    eventBus.on('refresh-validity-session', (validitySessionMinutes) => {
        sessionLogoutSeconds.value = validitySessionMinutes * 60
        sessionWarningSeconds.value = validitySessionMinutes * 60 - 20

        clearTimers()

        if (store.state.auth.status.loggedIn === true) {
            setTimers()
        }
    })
})

</script>

<template>

<div></div>

</template>
